export default class FlatGlassStructureUtils {
	static getSqmPrice(flatGlassStructure, priceVolumeCat) {
		if (!flatGlassStructure.sqmPrices && flatGlassStructure.sqmPrice) {
			return flatGlassStructure.sqmPrice; // pre-volume discount feature property name
		}
		const keys = Object.keys(flatGlassStructure.sqmPrices).reverse();

		let i = 0;
		while (i < keys.length) {
			const key = keys[i];
			const k = parseInt(key);

			if (k <= priceVolumeCat) {
				if (flatGlassStructure.sqmPrices[key]) {
					return flatGlassStructure.sqmPrices[key]; // first non-null value
				}
			}

			i += 1;
		}
	}
}
